<template>
  <div class="header">
    <div class="wraper_top">
      <div class="top">
        <div class="left">
          <el-popover
            placement="bottom"
            class="scan fl h30"
            width="195"
            trigger="click"
          >
            <p class="text_C">
              <img title="公众号" src="~/static/shanxi/app.png" />
            </p>
            <span slot="reference" class="bs_btn"
              >微信扫一扫
              <i class="el-icon-arrow-down" title="展开二维码"></i>
            </span>
          </el-popover>
          <div class="location" @click="citys = true">
            <img src="~/static/shanxi/index/location.png" alt="位置：" />
            <!-- <span class="location_span">
              {{ location }}
            </span> -->
            <a href="javascript:void(0);" class="select">切换城市</a>
          </div>
        </div>

        <div class="right">
          <img src="~/static/shanxi/index/lun.png" alt="" />
          <span class="toolbar_text" @click="open()">无障碍浏览</span>
          <span
            v-if="!isLogin"
            class="login_text"
            @mouseover="loginAlert = true"
            >登录/注册</span
          >
          <head-drop v-else class="login_text"></head-drop>
          <div class="login_alert" v-show="loginAlert">
            <el-button type="primary" @click="goRouters('/Login/')"
              ><img src="~/static/login/user1.png" alt="" />我要求职
            </el-button>
            <el-button
              type="primary"
              class="blue"
              @click="goRouters('/user/companyLogin')"
              ><img src="~/static/login/company1.png" alt="" />我要招聘
            </el-button>
            <a
              href="https://admin.cdpee.org.cn/"
              target="_blank"
              @click="loginAlert = false"
            >
              <el-button type="waring" class="org"
                ><img src="~/static/login/jigou1.png" alt="" />机构登录
              </el-button>
            </a>
          </div>
          <div
            class="weimu"
            v-show="loginAlert"
            title="登录/注册"
            @click="loginAlert = false"
          ></div>
        </div>
      </div>
    </div>
    <div class="wraper_bottom">
      <div class="bottom">
        <img src="~static/shanxi/logo.png" alt="" />
        <div class="nav">
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo tab_el_memu"
            mode="horizontal"
            :router="true"
            @select="handleSelect"
            active-text-color="#28a46d"
            v-show="type == 1 || type == 4"
          >
            <el-menu-item index="/">
              <div class="li">首页</div>
            </el-menu-item>
            <el-menu-item index="/job/">
              <div class="li">找工作</div>
            </el-menu-item>
            <el-menu-item index="/train">
              <div class="li">免费培训</div>
            </el-menu-item>
            <el-menu-item index="/news/">
              <div class="li">政策要闻</div>
            </el-menu-item>
            <el-menu-item index="/public/onlineJobfair/">
              <div class="li">专题活动</div>
            </el-menu-item>
            <el-menu-item index="/guide/">
              <div class="li">就业指导</div>
            </el-menu-item>
            <el-menu-item index="/evaluation/">
              <div class="li">能力测评</div>
            </el-menu-item>
            <el-menu-item index="/shopping/">
              <div class="li">商城</div>
            </el-menu-item>
          </el-menu>
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo tab_el_memu"
            mode="horizontal"
            :router="true"
            @select="handleSelect"
            v-show="type == 2"
          >
            <el-menu-item index="/enterprise">
              <div class="li">首页</div>
            </el-menu-item>
            <el-menu-item index="/news/">
              <div class="li">政策要闻</div>
            </el-menu-item>
            <el-menu-item index="/enterprise/post">
              <div class="li">职位管理</div>
            </el-menu-item>
            <el-menu-item index="/enterprise/recruiting">
              <div class="li">找人才</div>
            </el-menu-item>
            <el-menu-item index="/enterprise/netJob">
              <div class="li">网络招聘会</div>
            </el-menu-item>
            <!--            <el-menu-item index="/enterprise/3">商城</el-menu-item>-->
          </el-menu>
        </div>
      </div>
    </div>
    <city :show="citys" width="1000px" @close="citys = false"></city>
  </div>
</template>
<script>
import HeadDrop from "@/components/public/HeadDrop";
import city from "@/components/search/allCity";

export default {
  components: {
    HeadDrop,
    city,
  },
  data() {
    return {
      activeIndex: this.$route.path || "/",
      loginAlert: false,
      isLogin: "",
      type: "",
      citys: false,
    };
  },
  methods: {
    handleSelect(key, keyPath) {
      this.activeIndex = key;
      console.log(key, 222, keyPath);
    },
    goRouters(url) {
      this.$router.push(url);
    },
    open() {
      window.toolbar.open();
    },
  },
  created() {
    this.isLogin = JSON.parse(localStorage.getItem("userType")) || "";
    this.type = this.isLogin.userType || 1;
  },
};
</script>
<style scoped lang="less">
.header {
  width: 100%;
  position: relative;
  .wraper_top {
    width: 100%;
    background: #00924b;
    height: 30px;
    .top {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      font-weight: 400;
      color: #ffffff;
      position: relative;
      span {
        padding: 4px 0;
      }
      .location {
        margin-left: 12px;
        font-size: 16px;
        color: #66716c;
        display: inline-block;
        padding-top: 2px;
        img {
          vertical-align: middle;
          transform: translateY(-2px);
        }

        a {
          color: #fff;
          font-size: 14px;
        }
      }
      .right {
        display: flex;
        font-weight: 400;
        color: #ffffff;
        img {
          width: 22px;
          height: 24px;
          padding: 4px 0 0 0;
        }
        .toolbar_text {
          margin-right: 30px;
          cursor: pointer;
        }
        .login_text {
          width: 130px;
          background: #fc6c38;
          display: inline-block;
          text-align: center;
          cursor: pointer;
        }
      }
      .login_alert {
        position: absolute;
        right: 0;
        width: 306px;
        padding: 30px;
        background: white;
        border-radius: 0px 0px 6px 6px;
        z-index: 10000;
        margin-top: 30px;

        .el-button {
          width: 246px;
          height: 42px;
          line-height: 42px;
          padding: 0;
          margin-left: 0;
          margin-bottom: 24px;
          border: none;

          img {
            width: 18px !important;
            height: 18px !important;
            vertical-align: middle;
            transform: translateY(-1px);
            margin-right: 5px;
          }
        }

        .blue {
          background: #0090e2;
        }

        .org {
          margin-bottom: 0;
          color: white;
          background: #ff9600;
        }
      }
      .weimu {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: transparent;
        z-index: 9999;
      }
    }
  }
  .wraper_bottom {
    width: 100%;
    background: #ffffff;
    .bottom {
      height: 80px;
      width: 1200px;
      margin: 0 auto;
      position: relative;
      img {
        padding: 17px 21px 14px 0;
      }
      .nav {
        position: absolute;
        right: 0;
        bottom: 0;
        .el-menu-item {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          padding: 0 15px;
          &:hover {
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #00924b;
          }
        }
      }
    }
  }
  .el-menu--horizontal > .el-menu-item.is-active {
    color: #28a46d !important;
    font-weight: bold !important;
    border-bottom: solid 4px #28a46d !important;
  }
}
/deep/.el-dropdown-link {
  color: #fff;
}
/deep/.el-icon-arrow-down {
  color: #fff;
}
/deep/.el-dropdown-link {
  padding: 5px 0 0 0;
}
/deep/.el-menu.el-menu--horizontal {
  border: none;
}
</style>
